const EDITABLE_SELECTOR = 'input, textarea, select, [contenteditable="true"], [contenteditable=""]';

export function isEditableTarget(target: EventTarget | null): boolean {
    if (!(target instanceof HTMLElement)) {
        return false;
    }

    if (target.closest(EDITABLE_SELECTOR)) {
        const input = target.closest('input');

        if (input) {
            const type = (input.type || 'text').toLowerCase();

            return !['button', 'submit', 'reset', 'checkbox', 'radio', 'file', 'range'].includes(
                type
            );
        }

        return true;
    }

    return false;
}
